import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import type { DATASOURCE_TYPE } from '@/constants';
import MultiSelect from '@/shared/multi-select/multi-select.vue';
import { isEmptyArray } from '@/util/array-util';

export interface ChannelDatasourceProps {
  type: DATASOURCE_TYPE;
  agentId?: string;
  dataSourceId?: string;
  value?: any;
  disabled?: boolean;
  multiple?: boolean;
}

@Component({
  components: { MultiSelect },
})
export default class ChannelDatasourceField extends Vue {
  @Prop() public type: DATASOURCE_TYPE;
  @Prop() public value: any;
  @Prop() public disabled: boolean;
  @Prop() public multiple: boolean;

  @Emit('change') change(value: any) {}

  @Emit('everything:update') updateEverything(value: boolean) {}

  options = [
    { value: 'DOCUMENT', label: 'Document (doc, docx, odt…)' },
    { value: 'EXCEL', label: 'Excel (xls, xlsx, csv…)' },
    { value: 'PPT', label: 'Presentations (ppt, pptx…)' },
    { value: 'PDF', label: 'PDF file' },
    // { value: 'SPECIFIC_FILE', label: 'Specific file' },
    { value: 'TEXT', label: 'TXT' },
    { value: 'HTML', label: 'HTML' },
    // { value: 'IMAGE', label: 'Image' },
    // { value: 'SPECIFIC_FOLDER', label: 'Specific folder' },
    { value: 'HWP', label: 'HWP' },
  ];

  addValue() {
    this.value.push('');
    this.change(this.value);
  }

  removeValue(index: number) {
    this.value.splice(index, 1);
    this.change(this.value);
  }
}
